import { render, staticRenderFns } from "./CompanyObjectRefSelect.vue?vue&type=template&id=056a9b40&scoped=true"
import script from "./CompanyObjectRefSelect.vue?vue&type=script&lang=js"
export * from "./CompanyObjectRefSelect.vue?vue&type=script&lang=js"
import style0 from "./CompanyObjectRefSelect.vue?vue&type=style&index=0&id=056a9b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056a9b40",
  null
  
)

export default component.exports